export default "__VITE_ASSET__Baa1of9S__"